module.exports = __webpack_public_path__ + "assets/img/dh5.f26d5619.jpg";